import { ERROR_STATUS_CODES } from 'constants/General'
import { useInitiateCustomersRewardsWithdrawalMutation } from 'hooks/mutations/Rewards/useInitiateCustomersRewardsWithdrawalMutation'
import { useMFAMutation } from 'hooks/mutations/useMFAMutation'
import { BaseErrorResponse } from 'types/beneficiaries'
import { CustomersEarningsWithdrawalRequest } from 'types/rewards'
import { useRewardsTracking } from '../useRewardsTracking'

export const useRewardsCustomerWithdraw = ({
  onSuccess,
  onError,
}: {
  onSuccess: () => void
  onError: (error: BaseErrorResponse) => void
}) => {
  const { trackSuccess, trackError } = useRewardsTracking()

  const {
    mutate: initiateCustomersRewardsWithdrawal,
    isPending: isRewardsCustomerWithdrawPending,
  } = useInitiateCustomersRewardsWithdrawalMutation()

  const { mutate: initiateMFA } = useMFAMutation()

  const onRewardsCustomerWithdraw = (
    data: CustomersEarningsWithdrawalRequest,
    twoFactorCode?: string
  ) => {
    const { destinationWalletId } = data

    return initiateCustomersRewardsWithdrawal(data, {
      onError: error => {
        if (error?.status === ERROR_STATUS_CODES.AUTH_REQUIRED) {
          initiateMFA(
            {
              challenge: error?.data?.challenge?.value,
              tokenResponse: twoFactorCode,
              mfaCallbackUrl: error?.data?.callbackUrl,
            },
            {
              onSuccess: () => {
                trackSuccess('customerWithdraw')
                onSuccess()
              },
              onError: error => {
                trackError('customerWithdraw', error, {
                  walletId: destinationWalletId,
                })

                onError(error)
              },
            }
          )
        } else {
          trackError('customerWithdraw', error, {
            walletId: destinationWalletId,
          })
          onError(error)
        }
      },
    })
  }

  return {
    onRewardsCustomerWithdraw,
    isRewardsCustomerWithdrawPending,
  }
}
